import { Link } from "react-router-dom"
import Content from "../../../components/Content"
import { useAppSelector } from "../../../store/store"
import { formatDate } from "../../../utils/time"

const PlayerAwardsPage = () => {
    const player = useAppSelector(state => state.playerPage)
    return (
        <Content>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th scope="col" className="gap-2 px-6 py-3">
                            Premio
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Fecha
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {player?.awards?.map((playerAward, index) => (
                        <tr key={`${playerAward.player_id}_${playerAward.award_id}_${index}`} className="bg-white border-b">
                            <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                <Link to={`/awards/${playerAward.award_id}/overview`}>{playerAward?.award?.name}</Link>
                            </td>
                            <td className="px-6 py-4">
                                {formatDate(new Date(playerAward?.awarded_at as string))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Content>
    )
}

export default PlayerAwardsPage